import { createSelector } from 'reselect'

import storage from 'util/storage'
import { selectAccountPreferenceCrmSidebar } from 'selectors/app/selectAccountPreferences'

export { default as selectCurrentSearchTerm } from './selectCurrentSearchTerm'
export { default as selectCurrentSearchTerms } from './selectCurrentSearchTerms'

const storageValue = storage.get('newSidebarEnabled')
export const selectNewSideBarEnabled = createSelector(
  selectAccountPreferenceCrmSidebar,
  preference => {
    return storageValue === true || storageValue === false
      ? storageValue
      : preference
  }
)
